// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { modelInfo as HealthInsuranceCardUsSchema } from "./data/prebuilt-healthInsuranceCard.us.json";
export { HealthInsuranceCardUsSchema };